import Header from "./components/Header";
import Hero from "./components/Hero";
import Statement from "./components/Statement";
import WorksIndex from "./components/WorksIndex";
import ProjectPreviews from "./components/ProjectPreviews";
import Portfolio from "./components/Portfolio";
import UpcomingShow from "./components/UpcomingShow";
import Testimonials from "./components/Testimonials";
import Visit from "./components/Visit";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <Statement />
        <WorksIndex />
        <ProjectPreviews />
        <Portfolio />
        <UpcomingShow />
        <Testimonials />
        <Visit />
      </main>
      <Footer />
    </div>
  );
}